import React from 'react';
import PropTypes from 'prop-types';
import { CTA, Image } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const MenuHoverCard = ({ data, className, ...other }) => (
	<div
		className='hoverCard'
		data-testid='menu-hover-card'
		{...other}
	>
		{isValidArray(data?.image) && (
			<Image
				data={data.image[0]}
				className='!block'
			/>
		)}

		<div className='hoverCard-content bg-neutral-750 px-6 py-4'>
			{data?.heading && <p className='mb-2 text-base/snug tracking-[0.15px] text-white'>{data.heading}</p>}

			{isValidArray(data?.cta) && (
				<CTA
					data={data.cta[0]}
					className='!justify-start text-white !no-underline hover:!opacity-100 [&>.material-symbols-sharp]:!text-sm [&>.material-symbols-sharp]:no-underline [&>span]:underline [&>span]:decoration-neutral-100 [&>span]:decoration-2 [&>span]:underline-offset-4 [&>span]:hover:decoration-transparent'
				/>
			)}
		</div>
	</div>
);

MenuHoverCard.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default MenuHoverCard;
